// @flow
import React from 'react';
import type { EventSequence } from 'store/modules/events';
import { fromNow } from 'lib/common';
import { Link } from 'react-router-dom';
import FakeLink from 'components/common/FakeLink';
import cx from 'classnames';
import './EventSequences.scss';

type EventSequenceItemProps = {
  sequence: EventSequence,
  username: string,
  active: boolean,
};

type Props = {
  sequences: ?(EventSequence[]),
  username: string,
  currentEventId: string,
};

const EventSequenceItem = ({ sequence, username, active }: EventSequenceItemProps) => {
  const { title, body, meta, url_slug, created_at } = sequence;
  const to = `/@${username}/events/${url_slug}`;
  return (
    <FakeLink className={cx('EventSequenceItem', { active })} to={to}>
      <div className="date">{fromNow(created_at)}</div>
      <div className="title">
        <Link to={to}>{title}</Link>
      </div>
      <p>{(meta && meta.short_description) || body}</p>
    </FakeLink>
  );
};

const EventSequences = ({ sequences, username, currentEventId }: Props) => {
  if (!sequences || sequences.length === 0 || sequences.length === 1) return null;
  return (
    <div className="EventSequences">
      <div className="wrapper">
        <h3 className="title">다른 이벤트 둘러보기</h3>
        {sequences.map(s => (
          <EventSequenceItem
            key={s.id}
            sequence={s}
            username={username}
            active={s.id === currentEventId}
          />
        ))}
      </div>
    </div>
  );
};

export default EventSequences;



// WEBPACK FOOTER //
// ./src/components/event/EventSequences/EventSequences.js